export const TrophyFilled = () => (
  <svg focusable={false} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      d='M17.25 3H6.75a.75.75 0 00-.75.75V5H3.75a.75.75 0 00-.75.75v1.5a3.75 3.75 0 003.802 3.748 6.003 6.003 0 004.448 2.956V18h-1.5a.75.75 0 00-.75.75v.75h2.25-4.5a.75.75 0 100 1.5h10.5a.75.75 0 000-1.5h-4.5H15v-.75a.75.75 0 00-.75-.75h-1.5v-4.046a6.003 6.003 0 004.448-2.956A3.75 3.75 0 0021 7.25v-1.5a.75.75 0 00-.75-.75H18V3.75a.75.75 0 00-.75-.75zM18 9.372V6.5h1.5v.75A2.25 2.25 0 0118 9.372zM6 6.5H4.5v.75c0 .98.626 1.813 1.5 2.122V6.5z'
      clipRule='evenodd'
    />
  </svg>
);
